<template>
<div>
    <Breadcrumbs main="HR" submain="Payroll" title="Disbursement Sheet" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <!-- <div class="card-header">
                        <button class="btn btn-primary" type="submit" v-b-modal.modal-prevent-closing style="display: flex; gap: 12px; align-items: center;">
                            <i class="fa fa-light fa-plus"></i>
                            <h7>Add New Lead</h7>
                        </button>
                    </div> -->

                    <div class="card-body">
                        <b-row class="d-flex justify-content-center align-items-center">
                            <b-col xl="6" class="d-flex flex-wrap" style="gap: 20px">
                                <b-input-group style="width: 340px;">
                                    <b-form-input v-model="filter" placeholder="Type to Search" style="box-shadow: none;"></b-form-input>
                                    <b-input-group-append>
                                        <b-button @click="filter = ''">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>

                                <!-- <div style="display: flex; gap: 12px; align-items: center; color: white; background-color: #563EE0; padding: 2px 14px; max-width: fit-content; border-radius: 5px; cursor: pointer;" @click="toggleFilterShow()">
                                    <feather type="filter"></feather>
                                    <h7>Filter</h7>
                                </div> -->

                                <div style="display: flex; gap: 12px; align-items: center; color: white; background-color: #DC3545; padding: 2px 14px; max-width: fit-content; border-radius: 5px; cursor: pointer;" @click="clearFilter()" v-if="selectedOwner || selectedStage || selectedStatus || selectedSource || selectedLabel || filter || selectedClosureStatus">
                                    <feather type="x"></feather>
                                    <h7>Clear All</h7>
                                </div>
                            </b-col>

                            <b-col xl="6">
                                <b-form-group label-cols="3" label="Per page" class="mb-0 datatable-select w-100">
                                    <b-form-select v-model="perPage" :options="pageOptions" style="width: 100%;"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <div class="" style="margin-top: 22px;">
                            <div class="table-width">
                                <div v-if="!loading && !error">
                                    <div class="table-responsive datatable-vue">
                                        <b-table show-empty stacked="md" :items="items" :fields="tablefields" :filter="filter" :per-page="perPage" @filtered="onFiltered">

                                            <template #cell(index)="data">
                                                {{ data.index + 1 }}
                                            </template>

                                            <template #cell(title)="data">
                                                <router-link :to="`/hr/payroll/disbursement-sheet/detail/${data.item.id}`">
                                                       <strong>{{ data.item.title }}</strong>
                                                <br>
                                                <small class="text-muted">
                                                    {{ data.item.notes }}
                                                </small>
                                                </router-link>
                                            </template>

                                            <template #cell(payroll_sheet)="data">
                                                <span v-if="data.item.payroll_sheet">
                                                    {{ data.item.payroll_sheet.month }}/{{ data.item.payroll_sheet.year }}
                                                    <br>
                                                    <small class="text-muted">
                                                        {{ data.item.payroll_sheet.status }}
                                                    </small>
                                                </span>

                                                <span v-else class="text-muted">
                                                    N/A
                                                </span>
                                            </template>

                                            <template #cell(created_by)="data">
                                                <div class="d-flex align-items-center">

                                                    <div>
                                                        {{ data.item.created_by?.full_name || 'N/A' }}
                                                        <br>
                                                        <small class="text-muted">
                                                            {{ data.item.created_by?.email || 'N/A' }}
                                                        </small>
                                                    </div>
                                                </div>
                                            </template>

                                            <template #cell(total_entries)="data">
                                                {{ data.item.total_entries }}
                                            </template>

                                            <template #cell(total_pay_amount)="data">
                                                ৳ {{ Number(data.item.total_pay_amount || 0).toLocaleString() }}
                                            </template>

                                            <template #cell(status)="data">
                                                <b-badge @click="toggleDisbursement(data.item.id, data.item.status)" :variant="{
                                                    DRAFT: 'secondary',
                                                    APPROVED: 'success',
                                                    DISBURSED: 'primary'
                                                }[data.item.status] || 'warning'" style="cursor: pointer;">
                                                    {{ data.item.status }}
                                                </b-badge>
                                            </template>

                                            <template #cell(created_on)="data">
                                                {{ formatDate(data.item.created_on) }}
                                            </template>
                                            <template #cell(action)="data">
                                                <div class="d-flex align-items-center">

                                                

                                                    <!-- Edit -->
                                                    <!-- <feather type="edit" size="20px" class="mr-2" style="color:#28a745; cursor:pointer;" v-b-tooltip.hover title="Edit" @click="editItem(data.item)" /> -->

                                                 

                                                </div>
                                            </template>

                                        </b-table>
                                    </div>
                                </div>
                                <div v-else>
                                    <div class="loader-box">
                                        <div class="loader-10"></div>
                                    </div>
                                </div>

                                <b-col class="my-1 p-0">
                                    <b-row class="mt-3">
                                        <b-col xl="12" class="d-flex flex-wrap justify-content-start align-items-center" style="gap: 8px;">
                                            <span>

                                                <button class="pg-button" :disabled="currentPage === 1" @click="goToPage(1)">
                                                    <b-icon icon="chevron-double-left"></b-icon>
                                                </button>

                                                <button class="pg-button ml-2" :disabled="currentPage === 1" @click="goToPage(currentPage - 1)">
                                                    <b-icon icon="chevron-left"></b-icon>
                                                </button>
                                            </span>

                                            <span class="align-self-center">
                                                <span class="align-self-center">
                                                    <span class="d-flex align-items-center" style="gap: 6px;">
                                                        <span>Page</span>
                                                        <b-form-input v-model="pageInput" style="box-shadow: none; max-width: 40px;" @input="handlePageInput" @blur="validatePage" @keydown.enter="validatePage" :disabled="totalPages <= 1" :max="totalPages"></b-form-input>
                                                        <span>of {{ totalPages }}</span>
                                                    </span>
                                                </span>
                                            </span>

                                            <span>

                                                <button class="mr-2 pg-button" :disabled="currentPage === totalPages" @click="goToPage(currentPage + 1)">
                                                    <b-icon icon="chevron-right"></b-icon>
                                                </button>

                                                <button class="pg-button" :disabled="currentPage === totalPages" @click="goToPage(totalPages)">
                                                    <b-icon icon="chevron-double-right"></b-icon>
                                                </button>
                                            </span>
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Container-fluid Ends-->

    <!-- Delete Modal -->
    <!-- <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this lead?</div>
    </b-modal> -->

</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import Multiselect from 'vue-multiselect';
import Datepicker from 'vuejs-datepicker';
import moment from "moment";
export default {
    components: {
        Multiselect,
        Datepicker
    },

    data() {
        return {
            tablefields: [{
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'title',
                    label: 'Title',
                    sortable: true
                },
                {
                    key: 'payroll_sheet',
                    label: 'Payroll Sheet',
                    sortable: true
                },
                {
                    key: 'created_by',
                    label: 'Created By',
                    sortable: true
                },
                {
                    key: 'total_entries',
                    label: 'Entries',
                    sortable: true
                },
                {
                    key: 'total_pay_amount',
                    label: 'Amount',
                    sortable: true
                },
                {
                    key: 'status',
                    label: 'Status',
                    sortable: true
                },
                {
                    key: 'created_on',
                    label: 'Created On',
                    sortable: true
                },
                // {
                //     key: 'action',
                //     label: 'Action'
                // }
            ],
            assignedLabels: [],

            label: '',
            selected: null,

            lead_id: null,
            already_assigned_labels: [],

            delete_value: null,

            filter: null,

            filterShow: false,
            selectConnected: '',
            selectedLabel: null,

            update_lead_id: null,

            connected_list: [{
                    id: 1,
                    name: 'Yes',
                    value: 'True'
                },
                {
                    id: 2,
                    name: 'No',
                    value: 'False'
                }
            ],
            stage_list: [{
                    value: 'suspect',
                    text: 'Suspect'
                },
                {
                    value: 'qualified',
                    text: 'Qualified'
                },
                {
                    value: 'discovery',
                    text: 'Discovery'
                },
                {
                    value: 'demo',
                    text: 'Demo'
                },
                {
                    value: 'proposal',
                    text: 'Proposal'
                },
                {
                    value: 'trial',
                    text: 'Trial'
                },
                {
                    value: 'customer',
                    text: 'Customer'
                }
            ],

            status_list: [{
                    value: 'open',
                    text: 'Open'
                },
                {
                    value: 'active',
                    text: 'Active'
                },
                {
                    value: 'hold',
                    text: 'Hold'
                },
                {
                    value: 'lost',
                    text: 'Lost'
                },
                {
                    value: 'rejected',
                    text: 'Rejected'
                },
                {
                    value: 'converted',
                    text: 'Converted'
                }
            ],

            source_list: [{
                    value: 'linkedin',
                    text: 'LinkedIn'
                },
                {
                    value: 'referral',
                    text: 'Referral'
                },
                {
                    value: 'website',
                    text: 'Website'
                },
                {
                    value: 'cold_outreach',
                    text: 'Cold Outreach'
                },
                {
                    value: 'event',
                    text: 'Event'
                },
                {
                    value: 'other',
                    text: 'Other'
                }
            ],
            closure_list: [{
                    value: 'none',
                    text: 'None',
                },
                {
                    value: 'pending',
                    text: 'Pending',
                },
                {
                    value: 'approved',
                    text: 'Approved',
                },
                {
                    value: 'rejected',
                    text: 'Rejected',
                }

            ],

            initialLoad: true,

            totalRows: 1,
            currentPage: 1,
            perPage: 25,
            pageOptions: [25, 50, 100],
            isModifyingDate: false,
            nameState: null,
            loadingPage: false,
            pageInput: 1,
            pageInputDebounce: null,

            selectedStage: null,
            selectedStatus: null,
            selectedOwner: null,
            selectedSource: null,
            selectedClosureStatus: null,
            statusChange: ''

        };
    },

    computed: {

        ...mapState({
            items: state => state.payroll.disbursement_sheet,
            loading: state => state.payroll.disbursementLoading,
            error: state => state.payroll.disbursementError,
            count: state => state.payroll.disbursement_sheet_count,

        }),

        totalPages() {
            return Math.ceil(this.count / this.perPage);
        },

    },

    mounted() {

        const query = this.$route.query;
        this.currentPage = parseInt(query.page) || 1;
        this.pageInput = this.currentPage;
        this.perPage = parseInt(query.perPage) || 25;

        // if (query.category) {
        //     this.selectedCategory = query.category;
        // }
        // if (query.stage) {
        //     this.selectedStage = query.stage;
        // }
        // if (query.status) {
        //     this.selectedStatus = query.status;
        // }
        // if (query.owner) {
        //     this.selectedOwner = query.owner;
        // }
        // if (query.source) {
        //     this.selectedSource = query.source;
        // }
        // if (query.closure_status) {
        //     this.selectedClosureStatus = query.closure_status;
        // }

        // if (this.selectedLabel || this.selectedStage || this.selectedStatus || this.selectedOwner || this.selectedSource || this.selectedClosureStatus || this.filter) {
        //     this.filterShow = true;
        // }

        this.updateRouteQuery();
        this.fetchInitialUpdate();

    },

    watch: {

        currentPage(newVal, oldVal) {
            if (this.pageInput != newVal) {
                this.pageInput = newVal;
            }
            if (!this.loadingPage && !this.initialLoad) {
                this.updateRouteQuery();
                this.fetchData();
            }
        },
        perPage(newVal, oldVal) {
            if (!this.initialLoad) {
                this.currentPage = 1;
                this.pageInput = 1;
                this.updateRouteQuery();
                this.fetchData();
            }
        },

    },

    methods: {
        formatDate(date) {
            return date ?
                moment(date).format('DD MMM YYYY') :
                'N/A'
        },
        updateRouteQuery() {
            const query = {
                page: this.currentPage,
                perPage: this.perPage
            };

            if (JSON.stringify(this.$route.query) !== JSON.stringify(query)) {
                this.$router.replace({
                    path: this.$route.path,
                    query
                }).catch(err => {
                    if (err.name !== 'NavigationDuplicated') {
                        throw err;
                    }
                });
            }
        },
        fetchInitialUpdate() {
            this.$store.dispatch("payroll/fetchDisbursementList", {
                payrollSheet: this.$route.params.id,
                perPage: this.perPage,
                currentPage: this.currentPage,
            }).then(() => {
                this.totalRows = this.count;
                this.initialLoad = false;
            });
        },

        fetchData() {
            if (!this.initialLoad) {
                this.$store.dispatch("payroll/fetchDisbursementList", {
                    payrollSheet: this.$route.params.id,
                    perPage: this.perPage,
                    currentPage: this.currentPage,
                }).then(() => {
                    this.totalRows = this.count;
                });
            }
        },

        checkFormValidity() {
            const valid = this.$refs.form.checkValidity()
            this.nameState = valid
            return valid
        },
        handlePageInput() {

            if (this.pageInputDebounce) {
                clearTimeout(this.pageInputDebounce);
            }

            if (!this.pageInput || this.pageInput === '') {
                return;
            }

            this.pageInputDebounce = setTimeout(() => {
                this.validatePage();
            }, 800);
        },

        validatePage() {
            this.loadingPage = true;

            // Clear debounce timer
            if (this.pageInputDebounce) {
                clearTimeout(this.pageInputDebounce);
                this.pageInputDebounce = null;
            }

            const totalPages = this.totalPages;
            let page = parseInt(this.pageInput);

            if (!page || isNaN(page) || page < 1) {
                page = 1;
            } else if (page > totalPages) {
                page = totalPages;
            }

            this.pageInput = page;
            this.currentPage = page;

            this.loadingPage = false;
        },

        goToPage(page) {
            if (page < 1 || page > this.totalPages) return;
            this.currentPage = page;
            this.pageInput = page; // Update input too
        },

        clearFilter() {
            this.filterShow = false,
                this.filter = null

        },

        toggleFilterShow() {
            this.filterShow = !this.filterShow
        },

        toggleDisbursement(id, status) {
            let action = ''

            if (status === 'DRAFT') {
                action = 'approve'
            } else if (status === 'APPROVED') {
                action = 'disburse'
            }
            else if (status === 'DISBURSED') {
                    Swal.fire({
                        title: "Info!",
                        text: 'Already Disbursed',
                        icon: "info"
                    })
                    return
            }

            this.$store.dispatch("payroll/tooggleDisbursement", {
                id:id,
                status: action,
                payrollSheet: this.$route.params.id,
                perPage: this.perPage,
                currentPage: this.currentPage,
            }).then(response => {

                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    })
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    })
                }

            })
        },

        // onFiltered(filteredItems) {
        //     this.totalRows = filteredItems.length;
        //     this.currentPage = 1;
        // },

    }
};
</script>

<style scoped>

</style>
